import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['selectedResources']
  connect() {
    document.querySelector('#all_checkins_id').addEventListener('click', this.toggleAccordionSign)
    document.querySelector('#meetings_attended_id').addEventListener('click', this.toggleAccordionSign)
  }

  render(event) {
    var element = this.selectedResourcesTarget
    const [_data, _status, xhr] = event.detail

    element.innerHTML = xhr.response
    window.scrollTo(0,0)
  }

  toggleAccordionSign() {
    if ($(this).hasClass('fa-plus-square') === true)
      $(this).removeClass('fa-plus-square').addClass('fa-minus-square')
    else
      $(this).removeClass('fa-minus-square').addClass('fa-plus-square')
  }
}
